import React from "react";
import UserProfileLodge from "../lodge-components/userDropDownMenu";
import FriendsDropdown from "../lodge-components/FriendsDropdown";
import NotificationsDropdown from "../lodge-components/notifications";
import CurrencySelection from "../lodge-components/CurrencySelection";
import { EditProfileModal } from "../social/profile-page/EditProfileModal";
import useEditProfileModalStore from "@/stores/ui/editProfileModalStore";

interface PageHeaderBarProps {
  title: string;
  showCurrencySelection?: boolean;
}

const PageHeaderBar: React.FC<PageHeaderBarProps> = ({
  title,
  showCurrencySelection = true,
}) => {
  const { isOpen, closeModal } = useEditProfileModalStore();

  return (
    <>
      <div className="flex w-full flex-row items-center justify-between relative">
        <div className="flex items-center gap-4">
          <h1 className="relative text-3xl pb-1 font-semibold translate-y-0.5 leading-none bg-gradient-to-r from-blue-700 to-indigo-600 bg-clip-text text-transparent transition-all duration-300 ease-in-out tracking-tight cursor-default hover:scale-[1.02] hover:from-indigo-500 hover:to-blue-400">
            {title}
          </h1>
        </div>

        {/* RHS with Avatar Icon and Notifications */}
        <div className="flex flex-row space-x-4 items-center pt-1">
          {/* Friends */}
          <FriendsDropdown />
          {/* Notifications */}
          <NotificationsDropdown />
          {/* Currency Selection */}
          {showCurrencySelection && <CurrencySelection />}
          {/* Avatar and Name */}
          <UserProfileLodge />
        </div>
      </div>

      <EditProfileModal isOpen={isOpen} onClose={closeModal} />
    </>
  );
};

export default React.memo(PageHeaderBar);
